import { store } from '@/store'
import axios from 'axios'
import auth from '../api/auth'

const baseApiUrl = '/termine/api'

export const baseApi = axios.create({
  baseURL: baseApiUrl,
  headers: {
    'X-OEAMTC-RequestID': '',
  },
})

baseApi.interceptors.request.use(
  async (config) => {
    config.baseURL = baseApiUrl
    if (store.getters.sessionData?.access_token) {
      config.headers['Authorization'] = `Bearer ${store.getters.sessionData.access_token}`
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// Response interceptor for API calls
baseApi.interceptors.response.use(
  (response) => {
    return response
  },
  async function (error) {
    // const originalRequest = error.config;
    // if (error.response.status === 403 && !originalRequest._retry) {
    //   originalRequest._retry = true;
    //   const sessionData = await refreshSessionData(store.getters.sessionData.refresh_token);
    // 	// Retry the original request with the new access token
    // 	originalRequest.headers['Authorization'] = 'Bearer ' + sessionData.access_token;
    //   return baseApi(originalRequest);
    // }
    // return Promise.reject(error);
  }
)

async function refreshSessionData(refreshToken) {
  try {
    const res = await auth.refreshSessionData(refreshToken)
    store.commit('setSessionData', res.data)
    return res.data
  } catch (error) {
    console.error(error)
    store.commit('setSessionData', false)
  }
}

// The user logs in and get's an end-user access token
// Loop uses this access token to access the my-termine-api via the API-manager (so they set the Authorization header to Bearer <access-token>)
// The API-Manager checks the validity of the <access-token>.
// If the access token is valid, it removes the Authorization header and adds a X-JWT-Assertion header. in the X-JWT-Assertion header it puts the JWT token that should contain the CKNR (so the CKNR is not added by Loop, but by the API-manager)
// If the access token is invalid, a HTTP 401 error is returned
// my-termine-api reads the JWT token in the X-JWT-Assertion header and extracts the CKNR
